import { useEffect } from "react";

function MyJobQuoteWidgetComponent() {
  useEffect(() => {
    // Load external script
    const script = document.createElement("script");
    script.src = "https://www.myjobquote.co.uk/js/widget.js";
    script.async = true;
    script.onload = () => {
      // Initialize widget after script loads
      new window.MyJobQuoteWidget().init({
        targetId: "mjq-widget",
        userId: "usr_l2nt9vzw3xsdrhdawwjed5jqs6kx",
        badgeName: "standard-badge",
      });
    };
    document.body.appendChild(script);
  }, []);

  return <div id="mjq-widget" style={{transform: 'scale(.6)'}}></div>;
}

export default MyJobQuoteWidgetComponent;